import React, { useState, useEffect, useRef } from 'react';
import axios from '../Axiosinstance';
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHome,
  faBook,
  faCalendar,
  faGraduationCap,
  faCog,
  faQuestionCircle,
  faFolder,
  faUser,
  faSignOutAlt
} from "@fortawesome/free-solid-svg-icons";
import { Badge } from '@mui/material';
import MailIcon from '@mui/icons-material/Mail';
import 'bootstrap/dist/css/bootstrap.min.css';

import { Modal, Button } from 'react-bootstrap';
import { logoImage } from '../common';
import NotificationsIcon from '@mui/icons-material/Notifications';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useLocation } from "react-router-dom";


function App() {
  const [isResourcesOpen, setResourcesOpen] = useState(false);
  const [isHelpOpen, setHelpOpen] = useState(false);
  const [isAccountOpen, setAccountOpen] = useState(false);
  const [isNavOpen, setNavOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [notificationCount, setNotificationCount] = useState(0);
  const [notifications, setNotifications] = useState([]);
  const [showNotificationsModal, setShowNotificationsModal] = useState(false);

  const [hover, setHover] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const resourcesRef = useRef(null);
  const helpRef = useRef(null);
  const accountRef = useRef(null);
  const location = useLocation();


  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkScreenSize(); // Run on mount
    window.addEventListener("resize", checkScreenSize);

    return () => {
      window.removeEventListener("resize", checkScreenSize);
    };
  }, []);


  const openModal = () => {
    setShowModal(true);
  };


  const openNotificationsModal = () => {
    axios.get('admin-notifications/unseen')
      .then(response => {
        if (response.status === 200) {
          setNotifications(response.data);
          setShowNotificationsModal(true);
        }
      })
      .catch(error => {
        console.error('Error fetching notifications:', error);
      });
  };

  const closeNotificationsModal = () => {
    setShowNotificationsModal(false);
  };

  const toggleResources = (e) => {
    setResourcesOpen(!isResourcesOpen);
    setHelpOpen(false);
    setAccountOpen(false);
  };

  const toggleHelp = () => {
    setHelpOpen(!isHelpOpen);
    setResourcesOpen(false);
    setAccountOpen(false);
  };

  const toggleAccount = () => {
    setAccountOpen(!isAccountOpen);
    setResourcesOpen(false);
    setHelpOpen(false);
  };

  const [isHamburgerActive, setHamburgerActive] = useState(false);
  const [isNavActive, setNavActive] = useState(false);
  const navigate = useNavigate();
  const [studentName, setStudentName] = useState(null);
  const [profileUrl, setProfileUrl] = useState(null);

  const handleLogout = () => {
    localStorage.removeItem("loggedInUserId");
    localStorage.removeItem("usertype");
    localStorage.removeItem("studentteacherid");
    localStorage.removeItem('jwtToken');
    localStorage.removeItem('userId');
    localStorage.removeItem('username');
    document.title = "LMS-impluz";
    openModal();
  };

  useEffect(() => {
    const userId = localStorage.getItem("userId");

    if (userId) {
      axios.get(`home/user/${userId}`)
        .then((response) => {
          if (response.status === 200) {
            const data = response.data;
            localStorage.setItem("studentteacherid", data.sfid);
            document.title = `impluz - ${data.name}`;
            setStudentName(data.name);
            setProfileUrl(data.profile_Url);
          } else {
            throw new Error("Failed to fetch sfid");
          }
        })
        .catch((error) => {
          console.error(error.response);
          if (error == "AxiosError: Network Error")
            handleLogout();
        });
    }
  }, []);

  const toggleHamburger = () => {
    setHamburgerActive((prevState) => !prevState);
    setNavActive((prevState) => !prevState);
  };

  const toggleNav = () => {
    setNavOpen(!isNavOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (resourcesRef.current && !resourcesRef.current.contains(event.target)) {
        setResourcesOpen(false);
      }
      if (helpRef.current && !helpRef.current.contains(event.target)) {
        setHelpOpen(false);
      }
      if (accountRef.current && !accountRef.current.contains(event.target)) {
        setAccountOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Fetch notification count
  useEffect(() => {
    const fetchNotificationCount = () => {
      axios.get('admin-notifications/unseen-count')
        .then(response => {
          if (response.status === 200) {
            setNotificationCount(response.data); // Assuming response.data.count contains the count
          }
        })
        .catch(error => {
          console.error('Error fetching notification count:', error);
        });
    };

    // Fetch notifications every 5 minutes
    fetchNotificationCount();
    const intervalId = setInterval(fetchNotificationCount, 300000); // 300000 ms = 5 minutes

    return () => clearInterval(intervalId); // Cleanup interval on component unmount
  }, []);

  const markNotificationAsSeen = (id) => {
    axios.post(`admin-notifications/${id}/seen`)
      .then(() => {
        // Re-fetch the notifications after marking one as seen
        openNotificationsModal();
        // Optionally, update the notification count
        axios.get('admin-notifications/unseen-count')
          .then(response => {
            if (response.status === 200) {
              setNotificationCount(response.data);
            }
          })
          .catch(error => {
            console.error('Error fetching notification count:', error);
          });
      })
      .catch(error => {
        console.error('Error marking notification as seen:', error);
      });
  };

  const markAllNotificationsAsSeen = () => {
    axios.post('admin-notifications/mark-all-seen')
      .then(() => {
        // Re-fetch the notifications after marking all as seen
        openNotificationsModal();
        // Update the notification count
        axios.get('admin-notifications/unseen-count')
          .then(response => {
            if (response.status === 200) {
              setNotificationCount(response.data);
            }
          })
          .catch(error => {
            console.error('Error fetching notification count:', error);
          });
      })
      .catch(error => {
        console.error('Error marking all notifications as seen:', error);
      });
  };


  const itemStyle = {
    transition: 'background-color 0.3s',
    cursor: 'pointer',
    backgroundColor: hover ? '#f0f0f0' : 'transparent', // Change background color on hover
    color: hover ? '#FFC300' : 'inherit', // Change text/icon color on hover
    borderRadius: hover ? '30%' : '0', // Add border-radius on hover
    padding: '20px', // Optional: to ensure some space around the content
  };

  const handleBack = () => {
    navigate(-1);  // Goes back to the previous page in history
  };


  return (
    <div className={`App ${isNavOpen ? 'opened' : ''}`}>
      <nav>
        <div className="logo">
          <Link to='/Finance'>
            <img id='imglogo' src={logoImage} alt="logoImage" />
          </Link>
        </div>
        <button className={`btn-hamburger ${isNavOpen ? 'opened' : ''}`} onClick={toggleNav}>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </button>
        <ul className={`nav-menu ${isNavOpen ? 'opened' : ''}`} >
          <li className="nav-item"> <Link to="/Finance"><FontAwesomeIcon icon={faHome} /> Home </Link></li>
          {/* <li className="nav-item"><Link to="/Batches"> <FontAwesomeIcon icon={faBook} /> Batches </Link></li> */}
          {/* <li className="nav-item"><Link to="/Batch"><FontAwesomeIcon icon={faCalendar} /> Roaster </Link></li> */}
          {/* <li className="nav-item"><Link to="/Sswcommon"><FontAwesomeIcon icon={faGraduationCap} /> SSG_WSQ</Link></li> */}





          <li style={{ color: 'black' }} className={`nav-item dropdown ${isHelpOpen ? 'show' : ''}`} ref={helpRef}>

            <Link to='' onClick={toggleHelp}><FontAwesomeIcon icon={faQuestionCircle} /> Help <FontAwesomeIcon /></Link>

            <div className={`dropdown-menu ${isHelpOpen ? 'show' : ''}`}>

              <Link className="dropdown-item" to='/Chat'>Contact us</Link>

              {/* <Link className="dropdown-item" to=''>Live Chat</Link>

                 <Link className="dropdown-item" to=''>Remote Desktop</Link> */}

            </div>

          </li>



          {/* <li
            className="nav-item"
            style={itemStyle}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
          >
             <Badge
              badgeContent={notificationCount}
              onClick={openNotificationsModal}
              color="error"
           style={{ display: 'flex', alignItems: 'center' }} // Ensure badge and icon are centered
            >
              <NotificationsIcon />
              Notification
            </Badge> 
             <h6 style={{ margin: '0', fontSize: '16px', color: '#000' }}>Notification</h6> 
          </li> */}





          <span style={{ width: '40px' }}>
            <li className={`nav-item dropdown ${isAccountOpen ? 'show' : ''}`}>
              <Link to='' onClick={toggleAccount}>
                {profileUrl ? (
                  <img
                    src={profileUrl}
                    alt="Profile"
                    style={{ marginLeft: '5px', borderRadius: '50%', width: '50px', height: '50px' }}
                  />
                ) : (
                  <span
                    style={{
                      marginLeft: '5px',
                      borderRadius: '50%',
                      width: '50px',
                      height: '50px',
                      backgroundColor: 'gray',
                    }}
                  ></span>
                )}
                {studentName ? (
                  // Display only the first word of the student's name
                  studentName.split(' ')[0]
                ) : (
                  <span className="placeholder-text">Loading</span>
                )}
                <FontAwesomeIcon />
              </Link>

              <div className={`dropdown-menu ${isAccountOpen ? 'show' : ''}`} ref={accountRef}>
                <Link className="dropdown-item" to="/Profile">Profile</Link>
                <Link onClick={handleLogout} className="dropdown-item" to='/'>
                  <FontAwesomeIcon icon={faSignOutAlt} /> Log out
                </Link>
              </div>
            </li>
          </span>

        </ul>
      </nav>
      <div
        className="container"
        style={{
          marginBottom: window.innerWidth <= 1034 ? '4rem' : '1rem',
        }}
      >
      </div>
      {!isMobile && location.pathname !== "/Finance" && (
        <Button
          style={{ backgroundColor: '#1565C0' }}
          sx={{
            // backgroundColor: '#000000',
            color: 'white',
            borderRadius: '10px',
            padding: '8px 16px',
            minWidth: '80px',
            fontSize: { xs: '12px', sm: '14px', md: '16px' },
            '&:hover': { backgroundColor: '#0056b3' }
          }}
          onClick={handleBack}
        >
          <ArrowBackIcon />
        </Button>
      )}



    </div>
  );
}

export default App;
